// ── Runtime API base resolution ──────────────────────────────────────────────
// VITE_API_BASE_URL must be resolved at RUNTIME, not baked into the client bundle
// at build time. The root loader reads it from the SSR server's process.env (fed
// by the container env / Helm configmap) and injects it as `window.ENV`, so one
// image serves any environment — no rebuild to change the API domain.

declare global {
  interface Window {
    ENV?: { API_BASE_URL?: string };
  }
}

/**
 * Read a server-side env var without pulling @types/node into the client
 * tsconfig — `process` is only present in the SSR runtime.
 */
export function readServerEnv(name: string): string | undefined {
  const g = globalThis as { process?: { env?: Record<string, string | undefined> } };
  return g.process?.env?.[name];
}

/**
 * Resolve the API base URL at runtime.
 * - Browser: `window.ENV` (injected by the root loader).
 * - Server (SSR / prerender): `process.env`.
 * Falls back to the build-time value (dev via Vite `.env`) then same-origin `/api`.
 */
export function getApiBaseUrl(): string {
  if (typeof window !== "undefined") {
    return window.ENV?.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || "/api";
  }
  return readServerEnv("VITE_API_BASE_URL") || import.meta.env.VITE_API_BASE_URL || "/api";
}
